import React from 'react';
import { ActivityIndicator, View, StyleSheet } from 'react-native';
import Colors from '../constants/Colors';

export default function LoaderSmall({ ...props }) {
  if(!props.loading){ return null; }
  return (
      <View style={[styles.view, props.style ? props.style : {}]}>
        <ActivityIndicator size='small' color={Colors.lightBlue2} animating={props.loading} />
      </View>
  )
}

const styles = StyleSheet.create({
  view: {
    backgroundColor: 'rgba(0,0,0,0.55)',
    flex: 1,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
  }
})